import styled from 'styled-components';

export const BlockWrapper = styled.div`
  [class^='Blockstyle__Block-sc'] {
    background-color: inherit;
    padding: 48px 18px 12px 18px;

    @media (min-width: 768px) {
      padding: 64px 20px 8px 20px;
    }

    [class^='Blockstyle__ContentWrapper-sc'] {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      max-width: 1280px;
    }
  }
`;

export const HeaderWrapper = styled.div`
  h2 {
    margin-bottom: 0;
  }
`;

export const SubheaderWrapper = styled.div`
  h2 {
    margin-bottom: 48px !important;

    @media (max-width: 767px) {
      margin-bottom: 22px !important;
      font-weight: 700;
    }
  }
`;

export const BodyHeaderWrapper = styled.div`
  h2 {
    margin-bottom: 20px !important;
    font-size: 36px;
    line-height: 44px;

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
`;

export const BodyRichTextWrapper = styled.div`
  max-width: 728px;

  [class^='RichTextstyles__ParsedContentWrapper'] {
    margin-bottom: 18px;

    p {
      margin: 0;

      a {
        color: #BD0000;

        @media (max-width: 767px) {
          color: #E60000;
        }
      }
    }
  }
`;

export const IconWrapper = styled.div`
  svg {
    width: 72px;
    height: 72px;
    stroke-width: 2;
  }
`;
